import {
  AutoComplete,
  Button,
  DatePicker,
  Form,
  Input,
  Rate,
  Select,
  Spin,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useLocation, useParams, useHistory } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import {
  getPage,
  getParamValue,
  checkStatesAndPushToHistory,
} from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import { debounce } from "lodash";
import Empty from "../common/Empty";
import usePrevious from "../../hooks/PreviousState";
import moment from "moment";
const { RangePicker } = DatePicker;

const { Option } = Select;

const UserList = () => {
  const router = useLocation();
  const history = useHistory();
  const [status, setStatus] = useState(getParamValue(router.search, "status"));
  const [mobileNumber, setMobileNumber] = useState(
    getParamValue(router.search, "mobileNumber")
  );
  const [limit, setLimit] = useState(16);
  const [usersData, setUsersData] = useState({
    loading: false,
    data: null,
  });
  const [usersOptions, setUsersOptions] = useState({
    loading: false,
    list: null,
  });

  const [range, setRange] = useState<any>({
    from: null,
    to: null,
  });

  const fetchRef = useRef(null);

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const previousMobileNumber = usePrevious(mobileNumber);
  const previousStatus = usePrevious(status);

  const reseAllFieldData = () => {
    setStatus("");
    setMobileNumber("");
    setRange({
      from: null,
      to: null,
    });
    form.resetFields();
    history.replace(router.pathname);
    window.location.reload();
  };

  window.onbeforeunload = () => {
    saveCurrentStatesInLocalStorage();
  };
  function checkLocalStorageAndSetParams() {
    var retrievedObject = JSON.parse(
      localStorage.getItem("rememberCustomerList")
    );
    console.log("rememberCustomerList: ", retrievedObject);

    if (retrievedObject.mobileNumber)
      setMobileNumber(retrievedObject.mobileNumber);
    if (retrievedObject.status) setStatus(retrievedObject.status);
  }

  const saveCurrentStatesInLocalStorage = () => {
    localStorage.setItem(
      "rememberCustomerList",
      JSON.stringify({
        mobileNumber: mobileNumber,
        status: status,
        page: page,
      })
    );
  };
  const getUsers = useCallback(async () => {
    let pageReseted = false;
    if (localStorage.getItem("rememberCustomerList") != null) {
      checkLocalStorageAndSetParams();
      localStorage.removeItem("rememberCustomerList");
    } else {
      pageReseted = checkStatesAndPushToHistory(
        [previousMobileNumber, previousStatus],
        [mobileNumber, status],
        ["mobileNumber", "status"],
        history
      );
    }

    const from = moment(range.from)?.toISOString();
    const to = moment(range.to)?.toISOString();

    setUsersData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_AUTH_API}`;
    axios
      .get(
        `${encodedUri}/admin/user?` +
          (from ? `&startAt=${from}` : ``) +
          (to ? `&endAt=${to}` : ``) +
          (page ? `&page=${pageReseted ? 0 : page || 0}` : ``) +
          `&limit=${limit || 16}` +
          (status ? `&status=${status}` : ``) +
          (mobileNumber
            ? `&mobileNumber=%2B88${mobileNumber
                ?.toString()
                .replace("+88", "")}`
            : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setUsersData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setUsersData({ loading: false, data: [] });
        console.error("Users: Error", err);
      });
  }, [limit, mobileNumber, status, page, range]);

  const getUsersOptions = useCallback(
    async (mobileNumber) => {
      setUsersOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_AUTH_API}`;
      axios
        .get(
          `${encodedUri}/admin/user?` +
            `page=${0}` +
            `&limit=${20}` +
            (status ? `&status=${status}` : ``) +
            (mobileNumber ? `&mobileNumber=%2B88${mobileNumber}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setUsersOptions({
            loading: false,
            list: res.data?.users?.map((user) => ({
              label: user.fullName,
              value: user.mobileNumber,
            })),
          });
        })
        .catch((err) => {
          setUsersOptions({ loading: false, list: [] });
          console.error("Users: Error", err);
        });
    },
    [status]
  );

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  // const getUsersOptionsDebounce = (mobileNumber) => {
  //   const fetcher = (mobileNumber) => {
  //     getUsersOptions(mobileNumber);
  //   };

  //   return debounce(fetcher, 0.8);
  // };

  const getUsersOptionsDebounce = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setUsersOptions({ loading: false, list: null });

      if (fetchId !== fetchRef.current) {
        return;
      }

      getUsersOptions(value);
    };

    return debounce(loadOptions, 800);
  }, [getUsersOptions]);

  return (
    <React.Fragment>
      <TopHeading total={usersData?.data?.totalElements} />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="search" initialValue={mobileNumber}>
            <AutoComplete
              style={{ width: 300 }}
              onSearch={getUsersOptionsDebounce}
              onSelect={(val) => setMobileNumber(val.toString())}
              options={usersOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                usersOptions?.loading ? <Spin size="small" /> : null
              }
            >
              <Input.Search
                size="large"
                placeholder="Name or Phone Number"
                onSearch={(val) => setMobileNumber(val)}
                enterButton
                loading={usersOptions.loading}
                pattern={`[0-9]`}
                maxLength={11}
              />
            </AutoComplete>
          </Form.Item>

          <Form.Item initialValue={status}>
            <Select
              placeholder="User Status"
              onChange={(val) => setStatus(val)}
              value={status}
              style={{ minWidth: 250 }}
            >
              <Option value={""}>ALL</Option>
              <Option value={"REGULAR"}>REGULAR</Option>
              <Option value={"ACTIVE"}>ACTIVE</Option>
            </Select>
          </Form.Item>
          <Form.Item name="range">
            <RangePicker
              defaultValue={
                range.from != null && range.to != null
                  ? [moment(range.from), moment(range.to)]
                  : null
              }
              onChange={(e, f) => {
                console.log("momnet", moment.utc(f[0])?.toISOString());
                setRange({ from: f?.[0], to: f?.[1] });
              }}
              showTime={{
                hideDisabledOptions: true,
                defaultValue: [
                  moment("00:00:00", "HH:mm:ss"),
                  moment("23:59:59", "HH:mm:ss"),
                ],
              }}
              inputReadOnly
              allowClear
            />
          </Form.Item>
        </Form>
        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Name & Number</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Created At</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Rattings</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>

                  <div className="single-product-heading">
                    <span>Balance</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {usersData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {usersData?.data?.users?.length ? (
                    usersData?.data?.users?.map((user, index) => (
                      <React.Fragment key={index}>
                        <Link
                          to={`/users/${user?.id}/details`}
                          onClick={saveCurrentStatesInLocalStorage}
                        >
                          <div
                            className="single-product-wrapper"
                            // onClick={() => setSelectedUser(user)}
                          >
                            <div className="single-product">
                              <span className="name text-capitalize">
                                {user?.fullName} {" - "} <br />
                                {user?.mobileNumber?.split("+88")}
                              </span>
                            </div>
                            <div className="single-product">
                              <span className="name">
                                <small
                                  className={`font-capitalize ${
                                    moment().diff(user?.createdAt, "minutes") >=
                                    60
                                      ? "text-red-600"
                                      : "text-gray-800"
                                  }`}
                                >
                                  {moment(user?.createdAt).fromNow()}
                                </small>
                                <br />
                                <span className="name">
                                  {moment(user?.createdAt).format("lll")}
                                </span>
                              </span>
                            </div>

                            <div className="single-product">
                              <span className="name">
                                {user?.numberOfRating ? (
                                  <Rate value={user?.rating || 1} disabled />
                                ) : (
                                  <Rate value={1} disabled />
                                )}

                                <small className="ml-1">
                                  ({user?.numberOfRating || 0})
                                </small>
                              </span>
                            </div>

                            <div className="single-product">
                              <span
                                className={`radius-btn ${
                                  user?.status?.toLowerCase() || "initiated"
                                }-btn`}
                              >
                                {user?.status || "Initiated"}
                              </span>
                            </div>

                            <div className="single-product">
                              <span className="name">
                                &#2547;{user?.balance}
                              </span>
                            </div>
                          </div>
                        </Link>
                      </React.Fragment>
                    ))
                  ) : (
                    <Empty data="users" />
                  )}
                </div>
              </div>
            )}
          </div>

          <PaginationTwo
            {...usersData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserList;
